"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorIndexByNivo = void 0;
var ColorIndexByNivo;
(function (ColorIndexByNivo) {
    ColorIndexByNivo["DATA_KEY"] = "id";
    ColorIndexByNivo["X_AXIS_KEY"] = "indexValue";
})(ColorIndexByNivo = exports.ColorIndexByNivo || (exports.ColorIndexByNivo = {}));
//# sourceMappingURL=graph.js.map